import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=1aa0e094"
import script from "./SubMenu.vue?vue&type=script&lang=ts"
export * from "./SubMenu.vue?vue&type=script&lang=ts"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=1aa0e094&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports